import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getLocationHardwareCompanyOwnedItemListData,
  getLocationHardwareCompanyOwnedItemListDataByLocationId,
} from './mockData'
import type { THrid } from '~/types/models'
import type { ILocationHardwareCompanyOwnedItem } from '~/types/location/models'

interface GetLocationHardwareCompanyOwnedItemsResponse {
  data: ILocationHardwareCompanyOwnedItem[]
}

async function getListDataByLocationId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(
    `'Returning locationHardwareCompanyOwnedItems for location "${id}".`
  )
  const responseBody: GetLocationHardwareCompanyOwnedItemsResponse = {
    data: await getLocationHardwareCompanyOwnedItemListDataByLocationId(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

interface PostLocationHardwareCompanyOwnedItemResponse {
  hrid: THrid
}
const postLocationHardwareCompanyOwnedItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getLocationHardwareCompanyOwnedItemListData
  )
}

const patchLocationHardwareCompanyOwnedItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getLocationHardwareCompanyOwnedItemListData
  )
}

const deleteLocationHardwareCompanyOwnedItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getLocationHardwareCompanyOwnedItemListData
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/locationhardwarecompanyowneditems/:id',
    handler: getListDataByLocationId,
  },
  {
    method: 'post',
    path: '/api/locationhardwarecompanyowneditems',
    handler: postLocationHardwareCompanyOwnedItem,
  },
  {
    method: 'patch',
    path: '/api/locationhardwarecompanyowneditems/:id',
    handler: patchLocationHardwareCompanyOwnedItem,
  },
  {
    method: 'delete',
    path: '/api/locationhardwarecompanyowneditems/:id',
    handler: deleteLocationHardwareCompanyOwnedItem,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
